/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import { ChatRoomListItemFragmentDoc } from '../useChatRoomFilterResult.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
/** チャット状況 */
export type ChatMessageStatus =
  /** 返信済み */
  | 'Replied'
  /** 未読 */
  | 'Unread'
  /** 未返信 */
  | 'Unreplied';

export type ChatRoomFilterInput = {
  chatMessageStatuses?: Array<ChatMessageStatus> | null | undefined;
  lastMessageSentAt?: ChatRoomFilterLastMessageSendAtInput | null | undefined;
  memoStatuses?: Array<ChatRoomMemoStatus> | null | undefined;
  statuses?: Array<ChatRoomStatus> | null | undefined;
};

export type ChatRoomFilterLastMessageSendAtInput = {
  /** endedAtがnullの場合はstartedAt移行のもの全てを返す */
  endedAt?: TimeString | null | undefined;
  startedAt?: TimeString | null | undefined;
};

export type ChatRoomMemoStatus =
  | 'HAS_MEMO'
  | 'NO_MEMO';

export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type PersonalityType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type OwnChatRoomListQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
  filter?: Types.ChatRoomFilterInput | null | undefined;
}>;


export type OwnChatRoomListQuery = { chatRooms: { edges: Array<{ cursor: string, node: { id: string, updatedAt: TimeString, status: Types.ChatRoomStatus, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, match: { id: string, isAssigned: boolean, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, karte: { userComment: string } | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, memos: Array<{ id: string, content: string, createdAt: TimeString }> } } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean } } | null };

export type FetchChatRoomsOnUseOwnMatchesQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type FetchChatRoomsOnUseOwnMatchesQuery = { chatRoomsByIDs: Array<{ id: string, updatedAt: TimeString, status: Types.ChatRoomStatus, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, match: { id: string, isAssigned: boolean, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, karte: { userComment: string } | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, memos: Array<{ id: string, content: string, createdAt: TimeString }> }> };


export const OwnChatRoomListDocument = gql`
    query OwnChatRoomList($first: Int!, $after: String, $filter: ChatRoomFilterInput) {
  chatRooms(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        ...ChatRoomListItem
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ChatRoomListItemFragmentDoc}`;

/**
 * __useOwnChatRoomListQuery__
 *
 * To run a query within a Vue component, call `useOwnChatRoomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnChatRoomListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOwnChatRoomListQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   filter: // value for 'filter'
 * });
 */
export function useOwnChatRoomListQuery(variables: OwnChatRoomListQueryVariables | VueCompositionApi.Ref<OwnChatRoomListQueryVariables> | ReactiveFunction<OwnChatRoomListQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>(OwnChatRoomListDocument, variables, options);
}
export function useOwnChatRoomListLazyQuery(variables?: OwnChatRoomListQueryVariables | VueCompositionApi.Ref<OwnChatRoomListQueryVariables> | ReactiveFunction<OwnChatRoomListQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>(OwnChatRoomListDocument, variables, options);
}
export type OwnChatRoomListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OwnChatRoomListQuery, OwnChatRoomListQueryVariables>;
export const FetchChatRoomsOnUseOwnMatchesDocument = gql`
    query fetchChatRoomsOnUseOwnMatches($ids: [ID!]!) {
  chatRoomsByIDs(ids: $ids) {
    ...ChatRoomListItem
  }
}
    ${ChatRoomListItemFragmentDoc}`;

/**
 * __useFetchChatRoomsOnUseOwnMatchesQuery__
 *
 * To run a query within a Vue component, call `useFetchChatRoomsOnUseOwnMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChatRoomsOnUseOwnMatchesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchChatRoomsOnUseOwnMatchesQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useFetchChatRoomsOnUseOwnMatchesQuery(variables: FetchChatRoomsOnUseOwnMatchesQueryVariables | VueCompositionApi.Ref<FetchChatRoomsOnUseOwnMatchesQueryVariables> | ReactiveFunction<FetchChatRoomsOnUseOwnMatchesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>(FetchChatRoomsOnUseOwnMatchesDocument, variables, options);
}
export function useFetchChatRoomsOnUseOwnMatchesLazyQuery(variables?: FetchChatRoomsOnUseOwnMatchesQueryVariables | VueCompositionApi.Ref<FetchChatRoomsOnUseOwnMatchesQueryVariables> | ReactiveFunction<FetchChatRoomsOnUseOwnMatchesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>(FetchChatRoomsOnUseOwnMatchesDocument, variables, options);
}
export type FetchChatRoomsOnUseOwnMatchesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchChatRoomsOnUseOwnMatchesQuery, FetchChatRoomsOnUseOwnMatchesQueryVariables>;